import React, { useContext, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Spinner,
  Button,
  FormControl,
  Form,
} from "react-bootstrap";
import Pagination from "../Components/Pagination";
import Statics from "../Statics";
import ComponentContext from "../Context";

import {
  FaLinkedin,
  FaCloudDownloadAlt,
  FaInstagram,
  FaTwitter,
  FaTelegram,
  FaSearch,
} from "react-icons/fa";

const initialState = {
  firstName: "",
  lastName: "",
  loadingState: Statics.NOT_LOADED,
  current_page: 1,
  pageSize: 12,
  province: [],
  provinceId: "",
  provinceLoadingState: Statics.NOT_LOADED,
  teachers: [],
  totalCount: 0,
};

function reducer(state, action) {
  const { type, payload } = action;
  return { ...state, [type]: payload };
}

const Teachers = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    current_page,
    pageSize,
    totalCount,
    teachers,
    province,
    loadingState,
    provinceLoadingState,
    firstName,
    lastName,
    provinceId,
  } = state;

  const setPage = data => dispatch({ type: "current_page", payload: data });
  const setTotalCount = data => dispatch({ type: "totalCount", payload: data });
  const setTeachers = data => dispatch({ type: "teachers", payload: data });
  const setProvince = data => dispatch({ type: "province", payload: data });
  const setLoadingState = data =>
    dispatch({ type: "loadingState", payload: data });
  const setProvinceLoadingState = data =>
    dispatch({ type: "provinceLoadingState", payload: data });
  const setFirstName = data => dispatch({ type: "firstName", payload: data });
  const setLastName = data => dispatch({ type: "lastName", payload: data });
  const setProvinceId = data => dispatch({ type: "provinceId", payload: data });

  const context = useContext(ComponentContext);

  const getProvince = () => {
    setProvinceLoadingState(Statics.LOADING);
    context.ApiDriver.getProvince(
      {},
      (data, meta) => {
        setProvince(data.data);
        setProvinceLoadingState(Statics.LOADED);
      },
      error => {
        setProvinceLoadingState(Statics.CAUSED_ERROR);
      },
    );
  };

  const getTeachers = (p = current_page) => {
    setPage(p);
    setLoadingState(Statics.LOADING);

    context.ApiDriver.getTeachers(
      {
        current_page: p,
        page_size: pageSize,
        first_name: firstName,
        last_name: lastName,
        province_id: provinceId,
      },
      (data, meta) => {
        setTeachers(data.data);
        setTotalCount(data.meta.total);
        setPage(data.meta.current_page);
        setLoadingState(Statics.LOADED);
      },
      error => {
        setLoadingState(Statics.CAUSED_ERROR);
      },
    );
  };

  if (loadingState === Statics.NOT_LOADED) {
    getTeachers();
  }
  if (provinceLoadingState === Statics.NOT_LOADED) {
    getProvince();
  }
  return (
    <Row className="justify-content-center" style={{ marginTop: 30 }}>
      <Col>
        <Row className="justify-content-center" style={{ marginBottom: 5 }}>
          <Col md={3} sm={12} style={{ marginBottom: 5 }}>
            <FormControl
              onChange={e => setFirstName(e.target.value)}
              placeholder="نام"
            />
          </Col>
          <Col md={3} sm={12} style={{ marginBottom: 5 }}>
            <FormControl
              onChange={e => setLastName(e.target.value)}
              placeholder="نام خانوادگی"
            />
          </Col>
          <Col md={2} sm={12} style={{ marginBottom: 5 }}>
            <Form.Group controlId="exampleForm.ControlSelect1">
              <Form.Control
                as="select"
                onChange={e => setProvinceId(e.target.value)}>
                <option value="0">همه‌ی استان‌ها</option>
                {provinceLoadingState === Statics.LOADED
                  ? province.map(pr => (
                      <option value={pr.id}>{pr.title}</option>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={1} sm={12}>
            <Button
              onClick={() => {
                getTeachers(1);
              }}>
              <FaSearch />
            </Button>
          </Col>
        </Row>
        <hr />
        <Row className="justify-content-center ">
          <Col md={11} sm={12}>
            {loadingState === Statics.LOADING ||
            loadingState === Statics.NOT_LOADED ? (
              <Row
                className="justify-content-center"
                style={{ padding: "5rem 0" }}>
                <Spinner
                  animation="border"
                  variant="warning"
                  style={{ width: "5rem", height: "5rem" }}
                />
              </Row>
            ) : null}

            <Row className="workshop-list">
              {loadingState === Statics.LOADED && teachers.length > 0
                ? teachers.map(ts => (
                    <Col
                      md={3}
                      style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                      <Card
                        style={{
                          height: 450,
                          paddingTop: 27,
                          width: "16.5rem",
                          direction: "rtl",
                          textAlign: "right",
                        }}>
                        <Card.Img
                          variant="top"
                          src={ts.image}
                          style={{ width: "170px", height: "170px" }}
                          className="align-self-center"
                        />
                        <Card.Body>
                          <div style={{ height: 170 }}>
                            <Card.Title>
                              {ts.first_name + " " + ts.last_name}
                            </Card.Title>
                            <Card.Text className="teacher-body">
                              تحصیلات:
                              {ts.grade + " " + ts.field + " " + ts.university}
                              <br />
                              پست الکترونیکی : {ts.email}
                              <br />
                              شهر:
                              {ts.city.title + " - " + ts.city.province.title}
                              <br />
                              {"\u00A0"}
                              <a href={ts.resume}>
                                <FaCloudDownloadAlt />
                              </a>
                            </Card.Text>
                          </div>
                          <Card.Footer className="teacher-body d-flex justify-content-center">
                            {ts.links.soroush !== "" ? (
                              <a href={ts.links.soroush}>
                                <i className="icon icon-soroush"></i>
                              </a>
                            ) : null}
                            {ts.links.twitter !== "" ? (
                              <a href={ts.links.twitter}>
                                <FaTwitter />
                              </a>
                            ) : null}
                            {ts.links.instagram !== "" ? (
                              <a href={ts.links.instagram}>
                                <FaInstagram />
                              </a>
                            ) : null}
                            {ts.links.linkdin !== "" ? (
                              <a href={ts.links.linkdin}>
                                <FaLinkedin />
                              </a>
                            ) : null}
                            {ts.links.telegram !== "" ? (
                              <a href={ts.links.telegram}>
                                <FaTelegram />
                              </a>
                            ) : null}
                          </Card.Footer>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                : ""}
              {loadingState === Statics.LOADED && teachers.length === 0
                ? "موردی یافت نشد"
                : null}
            </Row>

            <Row
              className="justify-content-center"
              style={{ padding: "20px 0" }}>
              <Pagination
                onPageChange={getTeachers}
                currentPage={current_page}
                totalCount={totalCount}
                pageSize={pageSize}
              />
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Teachers;
